import { render, staticRenderFns } from "./NewRealEstateComparativeErrorList.vue?vue&type=template&id=428dc226&scoped=true&"
import script from "./NewRealEstateComparativeErrorList.vue?vue&type=script&lang=js&"
export * from "./NewRealEstateComparativeErrorList.vue?vue&type=script&lang=js&"
import style0 from "./NewRealEstateComparativeErrorList.vue?vue&type=style&index=0&id=428dc226&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "428dc226",
  null
  
)

export default component.exports